import { ComponentsOverrides, Theme } from '@mui/material';

export const AlertStyles: ComponentsOverrides<Theme>['MuiAlert'] = {
  root: {
    '&.MuiAlert-standardInfo': {
      backgroundColor: '#E3F2FD',
      color: '#0277BD',

      '& .MuiAlert-icon': {
        color: '#0277BD',
      }
    },
    '&.MuiAlert-standardSuccess': {
      backgroundColor: '#E8F5E9',
      color: '#388E3C',

      '& .MuiAlert-icon': {
        color: '#388E3C',
      }
    },
    '&.MuiAlert-standardWarning': {
      backgroundColor: '#FFF3E0',
      color: '#F57C00',

      '& .MuiAlert-icon': {
        color: '#F57C00',
      }
    },
    '&.MuiAlert-standardError': {
      backgroundColor: '#FFEBEE',
      color: '#D32F2F',

      '& .MuiAlert-icon': {
        color: '#D32F2F',
      }
    },
  },
};